// Types for Cluster Optimizer components

export interface ClusterInfo {
  name: string;
  apiEndpoint: string;
  region: string;
}

export interface NodeMetric {
  memory: {
    capacity: string;
    usage: string;
    usagePercentage: number;
  };
  cpu: {
    capacity: string;
    usage: string;
    usagePercentage: number;
  };
}

export interface NodeMetricsMap {
  [nodeName: string]: NodeMetric;
}

export interface PodMetric {
  name: string;
  namespace: string;
  memory: {
    usage: string;
    usageBytes: number;
    usageFormatted: string;
  };
  cpu: {
    usage: string;
  };
}

export interface PodMetricsMap {
  [podName: string]: PodMetric;
}

export interface ClusterMetrics {
  totalNodes: number;
  totalPods: number;
  runningPods: number;
  memoryUtilization: {
    capacityFormatted: string;
    usageFormatted: string;
    percentage: number;
  };
}

export interface SessionStats {
  total: number;
  noPod: number;
  missingPod: number;
  activeInPod: number;
}

export interface NodeData {
  nodeInfo: any;
  pods: any[];
  nodeType: 'gateway' | 'normal';
}

export interface NodePodsMap extends Map<string, NodeData> {}

export const NAMESPACE = 'tudo-blueticks-prod';

export const CLUSTER_INFO: ClusterInfo = {
  name: "serenix-eks-blueticks-prod",
  apiEndpoint: "35.224.227.175",
  region: "us-central1"
}; 